import './styles.css';
import React, { Component } from 'react';
import Card from '../../../CardNew';
import GeneralRibbonUtils from '../../GeneralRibbonUtils';
import { MORETOP } from '../../constants';
import Assets from '../../../../requests/apa/Asset';

class RibbonTop extends Component {
    constructor(props) {
        super(props);
        this.carruselTitle = props.carruselTitle;
        this.items = props.items;
        this.visibleItems = props.visibleItems;
        this.badgesUserType = props.badgesUserType;
        this.ignoreSeenLast = props.ignoreSeenLast;
        this.focusSettings = props.focusSettings;
        this.ribbonId = props.ribbonId;
        this.focusHandler = props.focusHandler;
        this.onClickHandler = props.onClickHandler;
        this.setMetricsEvent = props.setMetricsEvent;
        this.hideInnerTitle = props.hideInnerTitle;
        this.keyDownHandler = props.keyDownHandler;
        this.className = props.className;
        this.title = props.title;
        this.ribbonIndex = props.ribbonIndex;
        this.dataUpdateMetrics = props.dataUpdateMetrics;
        this.ribbonName = props.ribbonName;
    }

    render() {
        const imageTopNumbers = [
            {
                imgSrc: Assets.get('ribbons_top_numberOne_icon', ''),
            },
            {
                imgSrc: Assets.get('ribbons_top_numberTwo_icon', ''),
            },
            {
                imgSrc: Assets.get('ribbons_top_numberThree_icon', ''),
            },
            {
                imgSrc: Assets.get('ribbons_top_numberFour_icon', ''),
            },
            {
                imgSrc: Assets.get('ribbons_top_numberFive_icon', ''),
            },
            {
                imgSrc: Assets.get('ribbons_top_numberSix_icon', ''),
            },
            {
                imgSrc: Assets.get('ribbons_top_numberSeven_icon', ''),
            },
            {
                imgSrc: Assets.get('ribbons_top_numberEight_icon', ''),
            },
            {
                imgSrc: Assets.get('ribbons_top_numberNine_icon', ''),
            },
            {
                imgSrc: Assets.get('ribbons_top_numberTen_icon', ''),
            },
        ];

        return (
            <div className="ribbon-items ribbon-top">
                {this.visibleItems.map((node, index) => {
                    const node_item = node.item;
                    const badges = GeneralRibbonUtils.getBadgesHTML(this.badgesUserType, node_item);
                    const key = Math.random() * 10;
                    let uri = null;
                    const limitItemsTop = 9;
                    const dataMetricsRibbon = {
                        node_item,
                        node_location: location.pathname,
                        ribbon_title: this.props.carruselTitle || this.ribbonId,
                    };

                    if (this.props.type === 'user-profile') {
                        if (node && node_item && node_item.typeContent) {
                            uri = node_item.src;
                        } else {
                            uri = `/socialProfile/${node_item.id}`;
                        }
                    } else {
                        uri = node_item.src;
                    }
                    return (
                        <Card
                            unFocusHandler={this.unFocusHandler}
                            id={key}
                            key={key}
                            ribbonIndex={this.ribbonIndex}
                            ignoreSeenLast={this.ignoreSeenLast}
                            data={node_item}
                            group_id={node_item.group_id || node_item.id}
                            cover={node_item.cover}
                            hideTitles={this.props.hideTitles}
                            label={node_item.label}
                            type={MORETOP}
                            title={node_item.title}
                            badges={badges}
                            dataMetric={{
                                carruselTitle: this.carruselTitle,
                                cardPosition: GeneralRibbonUtils.getPosition(
                                    this.items,
                                    node_item.title
                                ),
                            }}
                            focusable={index === 0}
                            focusRight={`#${this.ribbonId} ${this.focusSettings.selector}`}
                            focusLeft={`#${this.ribbonId} ${this.focusSettings.selector}`}
                            focusHandler={this.focusHandler}
                            setMetricsEvent={this.setMetricsEvent}
                            clickHandler={node_item.clickHandler || this.onClickHandler}
                            sibling={node_item.sibling}
                            href={uri}
                            hideInnerTitle={this.hideInnerTitle}
                            bookmark={node_item.bookmark ? String(node_item.bookmark) : '0'}
                            keyDownHandler={this.keyDownHandler}
                            filterTV={node_item.filterTV ? node_item.filterTV : null}
                            imageNumbersTop={
                                node_item.index <= limitItemsTop
                                    ? imageTopNumbers[node_item.index]
                                    : ''
                            }
                            onClick={() => this.dataUpdateMetrics(dataMetricsRibbon)}
                            ribbonName={this.ribbonName} 
                        />
                    );
                })}
            </div>
        );
    }
}

export default RibbonTop;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonTop/index.jsx